import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';
import { Modal, Panel, Row, Col, Button } from 'react-bootstrap';
import { FieldList } from '../';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class ClientForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address : {},
      ...(this.props.client || {})
    }
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.fetchFields('Client');

    Api
      .fetchFieldGroupOrder('Client')
      .then(order => this.setState({ order }));
  }
  handleChange(value, name) {
    let copy_state = copy(this.state);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState(copy_state);
  }
  render() {
    return(
      <div className="client-form">
        {this.props.loading? (
          <div className="text-center"><i className="fa fa-spinner fa-spin"></i> <p>Fetching Fields.</p></div>
        ) : <FieldList
          groupOrder={this.state.order}
          entity={this.props.entity || this.state}
          onChange={this.props.onChange || this.handleChange}
          fields={this.props.fields}
        />}
      </div>
    )
  }
}

const mapStateToProps = ({fields}) => ({ loading: fields.fetching_fields, fields : (fields.Client || []) })

export default connect(mapStateToProps, Actions)(ClientForm);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-form.js